import { type ReactNode } from 'react'
import { ErrorBoundary } from '@mc/error-boundary'
import Experiment from '@mc/experiments-react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { EXPERIMENT_FLAG } from '../constants'
import { useDiscountPercent } from '../hooks/useDiscountPercent'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'
import { EXPERIMENT_I18N_NAMESPACE, i18nInstance } from '../i18n'

// variant_2, variant_3
const DiscountHeadline = withI18nContext(i18nInstance)(({
  control,
}: {
  control: ReactNode
}) => {
  const { t } = useTranslation(EXPERIMENT_I18N_NAMESPACE)
  const discount = useDiscountPercent()

  // Every promo carries percentages; handled anyway since flag variables are raw.
  if (discount === undefined) return <>{control}</>

  return (
    <p className='body mc-mt-2 mc-mt-md-1 mc-text--balance'>
      {t('discountHeadline', {
        instructors: getNumberOfInstructors(),
        discount,
      })}
    </p>
  )
})

export const HeadlineWrapper = ({ control }: { control: ReactNode }) => {
  const isEligible = useExperimentCriteria()

  if (!isEligible) return <ErrorBoundary>{control}</ErrorBoundary>

  return (
    <Experiment
      name={EXPERIMENT_FLAG}
      track={false}
      default={() => control}
      variant_1={() => control}
      variant_2={() => <DiscountHeadline control={control} />}
      variant_3={() => <DiscountHeadline control={control} />}
    />
  )
}
